import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_apparel_all: FaireCategoryEntity = {
  token: "cat_apparel-all",
  type: "category",
  name: "All apparel",
  level: 2,
  parentToken: "cat_apparel",
  href: "/category/apparel",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
